export type Route = {
  label: string;
  path: string;
  themeShortCode?: string;
};

export type Paths = {
  asct: Route;
  security: Route;
  versement: Route;
  proprete: Route;
  avitaillement: Route;
  login: Route;
  restauration: Route;
  resetPassword: Route;
  forgetPassword: Route;
  newAsct: Route;
  safety: Route;
  aetgv: Route;
  prmAssistance: Route;
  newSecurity: Route;
  newSafety: Route;
  newVersement: Route;
  newProprete: Route;
  newAvitaillement: Route;
  newAetgv: Route;
  prmAssistanceNew: Route;
  emargement: Route;
  newEmargement: Route;
  bulletincomposition: Route;
  newBulletinComposition: Route;
  newRestauration: Route;
  detailAsct: Route;
  detailSecurity: Route;
  detailSafety: Route;
  detailVersement: Route;
  detailPropreté: Route;
  detailAvitaillement: Route;
  detailAetgv: Route;
  prmAssistanceDetails: Route;
  detailEmargement: Route;
  detailBulletinComposition: Route;
  home: Route;
  fileViewer: Route;
  detailRestauration: Route;
};

export const paths: Paths = {
  asct: {
    label: 'Service ASCT',
    path: '/rapports/service-asct',
    themeShortCode: 'RSAS',
  },
  newAsct: {
    label: 'Nouveau rapport ASCT',
    path: '/rapports/service-asct/nouveau',
  },
  detailAsct: {
    label: 'Rapport Asct',
    path: '/rapports/service-asct/:reportId',
  },
  security: {
    label: 'Sécurité',
    path: '/rapports/securite',
    themeShortCode: 'RSCT',
  },
  newSecurity: {
    label: 'Nouveau rapport Sécurité',
    path: '/rapports/securite/nouveau',
  },
  detailSecurity: {
    label: 'Rapport Securité',
    path: '/rapports/securite/:reportId',
  },
  versement: {
    label: 'Versement',
    path: '/rapports/versement',
    themeShortCode: 'RVST',
  },
  newVersement: {
    label: 'Nouveau rapport Versement',
    path: '/rapports/versement/nouveau',
  },
  detailVersement: {
    label: 'Rapport Versement',
    path: '/rapports/versement/:reportId',
  },
  proprete: {
    label: 'Propreté',
    path: '/rapports/proprete',
    themeShortCode: 'RPNE',
  },
  newProprete: {
    label: 'Nouveau rapport Propreté',
    path: '/rapports/proprete/nouveau',
  },
  detailRestauration: {
    label: 'Rapport Propreté',
    path: '/rapports/proprete/:reportId',
  },
  newRestauration: {
    label: 'Nouveau rapport Restauration',
    path: '/rapports/restauration/nouveau',
  },
  restauration: {
    label: 'Restauration',
    path: '/rapports/restauration',
    themeShortCode: 'RRES',
  },
  bulletincomposition: {
    label: 'Bulletin de composition',
    path: '/rapports/bulletin-composition',
    themeShortCode: 'RBCO',
  },
  newBulletinComposition: {
    label: 'Nouveau rapport Bulletin de composition',
    path: '/rapports/bulletin-composition/nouveau',
  },

  detailPropreté: {
    label: 'Rapport Propreté',
    path: '/rapports/proprete/:reportId',
  },
  avitaillement: {
    label: 'Prestataire Avitaillement',
    path: '/rapports/avitaillement',
    themeShortCode: 'RPAV',
  },
  newAvitaillement: {
    label: 'Nouveau rapport Prestataire Avitaillement',
    path: '/rapports/avitaillement/nouveau',
  },
  detailAvitaillement: {
    label: 'Rapport Prestataire Avitaillement',
    path: '/rapports/avitaillement/:reportId',
  },
  detailBulletinComposition: {
    label: 'Rapport Bulletin de composition',
    path: '/rapports/avitaillement/:reportId',
  },
  login: {
    label: 'Login',
    path: '/login',
  },
  resetPassword: {
    label: 'Reset Password',
    path: '/reset-password',
  },
  forgetPassword: {
    label: 'Mot de pass oublié',
    path: '/forget-password',
  },
  safety: {
    label: 'Sureté',
    path: '/rapports/surete',
    themeShortCode: 'RSRT',
  },
  newSafety: {
    label: 'Nouveau Rapport Sureté',
    path: '/rapports/surete/nouveau',
  },
  detailSafety: {
    label: 'Rapport Sureté',
    path: '/rapports/surete/:report',
  },
  aetgv: {
    label: 'ETGV PACA',
    path: '/rapports/etgv-paca',
    themeShortCode: 'REPA',
  },
  newAetgv: {
    label: 'Nouveau rapport ETGV PACA',
    path: '/rapports/etgv-paca/nouveau',
  },
  detailAetgv: {
    label: 'Rapport ETGV PACA',
    path: '/rapports/etgv-paca/:reportId',
  },
  prmAssistance: {
    label: 'Assistance PMR',
    path: '/rapports/pmr',
    themeShortCode: 'RPMR',
  },
  prmAssistanceNew: {
    label: 'Nouveau rapport Assistance PMR',
    path: '/rapports/pmr/nouveau',
  },
  prmAssistanceDetails: {
    label: 'Rapport Assistance PMR',
    path: '/rapports/pmr/:reportId',
  },
  emargement: {
    label: 'Emargements',
    path: '/emargements',
  },
  newEmargement: {
    label: 'Nouvel Emargement',
    path: '/emargements/nouveau',
  },
  detailEmargement: {
    label: 'Emargement',
    path: '/emargements/:emargementId',
  },
  fileViewer: {
    label: 'Aperçu des images',
    path: '/files/:reportId/:name/:hash',
  },
  home: {
    label: ' ',
    path: '/',
  },
};
